import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { DateTime } from 'luxon';

import Table from '../../../components/Table/Table';
import TableHead from '../../../components/Table/TableHead';
import TableRow from '../../../components/Table/TableRow';
import TableHeadData from '../../../components/Table/TableHeadData';
import TableBody from '../../../components/Table/TableBody';
import TableData from '../../../components/Table/TableData';
import PermissionsGate from '../../../components/PermissionsGate/PermissionsGate';
import AccessDenied from '../../../components/AccessDenied/AccessDenied';
import { permissions } from '../../../common/permissionGroup';
import Layout from '../../../layout/Layout';
import Card from '../../../components/Card/Card';
import EmptyTable from '../../../components/Table/EmptyTable';
import ButtonTypes from '../../../constants/buttonTypes';
import Badge from '../../../components/Badge/Badge';
import Pagination from '../../../components/Pagination/Pagination';
import { IconCode } from '../../../assets/icon';
import Button from '../../../components/Button/Button';
import Modal from '../../../components/Modal/Modal';
import getFailedImportRows from '../../../thunks/jobs/getFailedImportRows';

const logButtonClassName = 'h-[32px] w-[32px] p-0';
const logIconClassName = 'h-[18px] w-[18px] text-info';

function FailedImportRows() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [logsData, setLogsData] = useState();

  const {
    getFailedImportRows: {
      loading: getFailedImportRowsLoading,
      data: getFailedImportRowsData = [],
      current_page: currentPage,
      last_page: lastPage
    },
  } = useSelector((state) => ({
    getFailedImportRows: state.getFailedImportRows
  }));

  const breadcrumbs = {
    pageTitle: 'Jobs',
    history: [
      {
        title: 'Home',
        onClick: () => navigate('/')
      },
      {
        title: 'Job Failed',
      },
    ]
  };

  const onPagePress = (page) => {
    dispatch(getFailedImportRows({
      page
    }));
  };

  useEffect(() => {
    dispatch(getFailedImportRows());
  }, []);

  return (
    <Layout breadcrumbs={breadcrumbs} pageTitle="Failed Import Task">
      <PermissionsGate
        can={permissions.JOBS_READ}
        errorComponent={<AccessDenied />}
      >
        <Card
          showHeader={false}
          headerBordered={false}
          footer={(
            <div className="d-flex d-justify-end">
              <Pagination
                currentPage={currentPage}
                onPagePress={onPagePress}
                lastPage={lastPage}
              />
            </div>
          )}
          footerBordered={false}
        >
          <div>
            <Table loading={getFailedImportRowsLoading}>
              <TableHead>
                <TableRow bordered>
                  <TableHeadData>
                    Id
                  </TableHeadData>
                  <TableHeadData>
                    Row Data
                  </TableHeadData>
                  <TableHeadData>
                    Error Message
                  </TableHeadData>
                  <TableHeadData>
                    Create At
                  </TableHeadData>
                  <TableHeadData>
                    Update At
                  </TableHeadData>
                </TableRow>
              </TableHead>
              <TableBody>
                {getFailedImportRowsData?.length
                  ? getFailedImportRowsData.map((job) => {
                    const {
                      id,
                      row_data: rowData,
                      error_message: errorMessage,
                      created_at: createdAt,
                      updated_at: updatedAt,
                    } = job || {};
                    return (
                      <TableRow>
                        <TableData>
                          {id}
                        </TableData>
                        <TableData>
                          <Button
                            containerStyle={logButtonClassName}
                            type={ButtonTypes.LIGHT}
                            icon={<IconCode className={logIconClassName} />}
                            onClick={() => setLogsData(rowData)}
                          />
                        </TableData>
                        <TableData>
                          <Button
                            containerStyle={logButtonClassName}
                            type={ButtonTypes.LIGHT}
                            icon={<IconCode className={logIconClassName} />}
                            onClick={() => setLogsData(JSON.parse(errorMessage))}
                          />
                        </TableData>

                        <TableData>
                          <Badge
                            type={ButtonTypes.LIGHT}
                            text={DateTime.fromISO(createdAt, { zone: 'utc' })
                              .setLocale() // або інша мова
                              .toRelative()}
                          />
                        </TableData>
                        <TableData>
                          {updatedAt ? (
                            <Badge
                              type={ButtonTypes.LIGHT}
                              text={DateTime.fromISO(updatedAt, { zone: 'utc' })
                                .setLocale() // або інша мова
                                .toRelative()}
                            />
                          ) : '---'}
                        </TableData>
                        <TableData />
                      </TableRow>
                    );
                  })
                  : (<EmptyTable colSpan={7} text="No any data find" />)}
              </TableBody>
            </Table>
          </div>
        </Card>
        <Modal visible={!!logsData} toggleVisible={() => setLogsData(false)} hideSaveBtn>
          <div style={{ overflow: 'auto' }}>
            <pre>
              {logsData && JSON.stringify(logsData, null, 2)}
            </pre>
          </div>
        </Modal>
      </PermissionsGate>
    </Layout>
  );
}

export default FailedImportRows;
